import React, { useEffect, useLayoutEffect } from "react";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router";
import styled, { keyframes } from "styled-components";

import { devices } from "../../styles.js";

export default function Background() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.pathname === "/") {
      document.getElementsByClassName(
        "background-content-intro"
      )[0].style.opacity = 1;
    }
  }, [location]);

  useEffect(() => {
    window.onload = () => {
      // analytics event for page load
      const tagManagerArgs = {
        dataLayer: {
          event: "gaQuizEvent",
          eventAction: "Take the Next Step",
          eventLabel: "Step 1 - Take the Next Step",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    };
  }, []);

  return (
    <div>
     
        <BackgroundContent className="background-content-intro">
          <div>
            <BackgroundImage
              id="background-image"
              alt="background"
              src="./background-imgs/Mary_door-1.png"
              className="background-content-fadeOut"
            />
            
          </div>
        </BackgroundContent>
    
    </div>
  );
}

const BackgroundContent = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 750px;
  z-index: -1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  //background: rgba(83, 104, 145, 0.6);
  /*box-shadow: 0 2px 6px 2px rgba(60, 64, 67, 0.15),
    0 1px 2px 0 rgba(60, 64, 67, 0.3);*/

  @media ${devices.M} {
    right: 0px;
  }

  div {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;

    img {
      /*position: absolute;

      @media ${devices.S} {
        transform: scale(0.84) translate(-21px, -68px);

        @media (min-width: 401px) and (max-width: 450px) {
          transform: scale(0.84) translate(-51px, -69px);
        }
      }*/
    }
  }
`;

const BackgroundAnimation = keyframes`
  /*0%{
    transform: translate3d(0, 0, 0);
  }
  50%{
    transform: translate3d(-100px, 0, 0);
  }
  100%{ 
    transform: translate3d(0, 0, 0);
  }*/
`;

const BackgroundImage = styled.img`
  position: absolute;
  height: 371px;
  animation: ${BackgroundAnimation} 0.3s linear infinite;
  
  @media ${devices.S} {
    height: 255px;
    position: absolute;
    right: -10px;
  }

  @media ${devices.M} {
    right: 0;
  }

  @media ${devices.L} {
    width: 1978px;
    height: 750px;
    position: absolute;
    max-width: none;
  }

  @media (min-width: 932px) and (max-width: 1025px) {
    top: -122px;
    height: 593px;
  }

  @media (min-width: 1441px) {
    right: 0;
  }

  @media (min-width: 2000px) {
    margin-left: auto;
    left: 0;
    right: 0;
    position: absolute;
    animation: none;
  }
`;